import { defineComponent as b, computed as a, openBlock as n, createElementBlock as d, normalizeClass as r, createElementVNode as s, renderSlot as i, createVNode as f, unref as m, createTextVNode as h, toDisplayString as v, createCommentVNode as w } from "vue";
import x from "../../../icons/generated/IconChevronDown.vue2.js";
import { tw as t } from "../../../utils/tailwind.js";
const y = { class: "pointer-events-none absolute inset-y-0 right-8 flex select-none items-center" }, B = {
  key: 0,
  class: "text-static-default-low caption pointer-events-none absolute inset-x-12 top-0 flex items-center pr-16"
}, C = /* @__PURE__ */ b({
  name: "InputSmallSelectButton",
  __name: "InputSmallSelectButton",
  props: {
    hasError: { type: Boolean },
    focused: { type: Boolean },
    disabled: { type: Boolean },
    hasSelectedOption: { type: Boolean },
    required: { type: Boolean }
  },
  setup(o) {
    const e = o, c = a(() => [
      t`rounded-sm relative block h-32 w-full transition-colors outline-none`,
      e.disabled ? t`bg-static-default-low-disabled text-action-default-hi-disabled pointer-events-none` : t`bg-static-default-low hover:bg-static-default-low-hover text-action-default-hi`
    ]), u = a(() => [
      t`body-2-bold flex h-full items-center text-start`,
      !e.disabled && e.hasError && e.hasSelectedOption && t`text-action-danger-hi`
    ]), p = a(() => [
      t`pointer-events-none absolute inset-0 rounded-sm border border-solid transition-colors`,
      e.disabled && t`border-action-default-low-disabled`,
      !e.disabled && !e.focused && !e.hasError && t`border-action-default-low`,
      !e.disabled && !e.focused && e.hasError && t`border-action-danger-low`,
      !e.disabled && e.focused && !e.hasError && t`border-retina border-action-default-low-pressed`,
      !e.disabled && e.focused && e.hasError && t`border-retina border-action-danger-low-pressed`
    ]);
    return (l, g) => (n(), d("span", {
      class: r(c.value)
    }, [
      s("span", {
        "aria-hidden": "true",
        class: r(p.value)
      }, null, 2),
      s("div", {
        class: r(u.value)
      }, [
        i(l.$slots, "value")
      ], 2),
      s("div", y, [
        f(m(x), { size: "20" })
      ]),
      o.required ? (n(), d("span", B, [
        i(l.$slots, "label"),
        h(v(o.required ? " *" : ""), 1)
      ])) : w("", !0)
    ], 2));
  }
});
export {
  C as default
};
